
import * as moment from 'moment'
import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ActionSheetController, Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import { NL_ProgramAyarlari } from '../models/NL_ProgramAyarlari';
import { NL_Servis } from '../models/NL_Servis';

declare var require: any;
let { json2excel } = require('js2excel');


@Injectable()
export class Ortak {


  static sqlType = "web";
  static timerOrtak: any;


  constructor(public alert?: AlertController,
    public loadingCtrl?: LoadingController,
    public actionSheet?: ActionSheetController,
    public platform?: Platform) {

  }

  turkishToLower(deger) {
    var letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
    deger = deger.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) { return letters[letter]; })
    return deger.toLowerCase();
  }
  public tarih(tarih: Date, format = "YYYY-MM-DD") {
    return moment(tarih).locale("tr").format(format);
  }
  public tarih2(tarih: Date, format = "DD-MM-YYYY HH:mm") {
    return moment(tarih).locale("tr").format(format);
  }




  public get ServisUrl() {
    const servisBilgisi = this.storageServisBilgisiGetir;
    if (servisBilgisi && servisBilgisi.ADRES) {
      return servisBilgisi.ADRES + "/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
    }
    // Geçici olarak localhost kullanıyoruz
   // return "http://192.168.1.62:3131/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
     return "https://tepeli.dnsservis.com/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
    // return "https://192.168.1.62:1819/Api/Servis.aspx?key=N9ySoNLaS2_18&t=";
  }

  public InternetConnection() {
    //var networkState = navigator.connection.type;

    // return Network.type;
  }

  showLoadingControl(contentString) {
    let loading = this.loadingCtrl.create({
      content: contentString
    });
    loading.present();
    return loading;
    // this.bllmiktar.syncMiktarBirimDetaylar()
    //   .then(a => {
    //     loading.dismiss();
    //   });
  }

  hideLoadingControl(loadingControl: any) {
    loadingControl.dismiss();
  }
  showBasicAlert(baslik: string, mesaj: string) {
    let alert = this.alert.create({
      title: baslik,
      subTitle: mesaj,
      buttons: ['Tamam']
    });
    alert.present();

  }
  showConfirmAlert(baslik: string, mesaj: string) {
    return new Promise((kabul, ret) => {
      let confirm = this.alert.create({
        title: baslik,
        message: mesaj,
        buttons: [

          {
            text: 'Evet',
            handler: () => {
              kabul();
            }
          },
          {
            text: 'Hayır',
            handler: () => {
              ret();
            }
          }
        ]
      });
      confirm.present();
    })

  }
  storagePersonelEkle(personel: any) {


    localStorage.setItem("personel", JSON.stringify(personel));

  };

  get storagePersonelGetir(): any {

    return JSON.parse(localStorage.getItem("personel"));
  };
  storeagePersonelCikar() {

    localStorage.removeItem("personel");
  };

  showErrorAlert() {
    let alert = this.alert.create({
      title: "Hata",
      subTitle: "İşlem sırasında hata oluştu",
      buttons: ['Tamam']
    });
    alert.present();
  }
  get storageServisBilgisiGetir(): NL_Servis {
    const servisBilgisi = localStorage.getItem("servisBilgisi");
    if (servisBilgisi) {
      return JSON.parse(servisBilgisi);
    }
    return null;
  };
  get StAyarGetir(): NL_ProgramAyarlari {
    return JSON.parse(localStorage.getItem("ayarbilgisi"))
  }

  get storageGunTarihiGetir(): any {
    // return this.storage.get('personel').then((value) => {
    //   return JSON.parse(value);
    // });
    return localStorage.getItem("gunTarihi");
  };
  get storageSunucuAdresiGetir(): any {
    const servisBilgisi = this.storageServisBilgisiGetir;
    if (servisBilgisi && servisBilgisi.ADRES) {
      return servisBilgisi.ADRES;
    }
     return "https://tepeli.dnsservis.com";
    //return "http://192.168.1.62:3131";
  };

  storageGunTarihiEkle(gunTarihi) {

    // this.storage.set("personel", JSON.stringify(personel));
    localStorage.setItem("gunTarihi", gunTarihi);

  };
  storageServisBilgisiEkle(servisBilgisi) {

    //this.storage.set("servisBilgisi", JSON.stringify(servisBilgisi));
    localStorage.setItem("servisBilgisi", JSON.stringify(servisBilgisi));
  }
  storageProgramAyarEkle(ayarbilgisi) {
    localStorage.setItem("ayarbilgisi", JSON.stringify(ayarbilgisi));
  }
  storagekullaniciekle(kullanicibilgisi) {
    localStorage.setItem("kullanicibilfisi", JSON.stringify(kullanicibilgisi));
  }

  alertalisfaturakaydet(tarih) {
    return new Promise((res, err) => {
      // var sonuc = false;
      let prompt = this.alert.create({
        title: "Fatura Özellikleri",
        message: "",
        inputs: [
          {
            placeholder: "Alt Satırdan Vade Tarihi Seçiniz..",
          },
          {
            name: 'vadetarih',
            placeholder: "Vade Tarihi",

            type: "date",
            value: tarih
          },
          {
            name: 'aciklama',
            placeholder: "Fatura açıklaması varsa giriniz..",
            type: "text",
          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  

  alertMiktarDegistirPenc()
  {
    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Miktar  giriniz.",
        message: "İşleme devam edebilmek için  miktar giriniz.",
        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'number',
   
          },
      
          
        ],
     
        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {
              
            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertFiyatDegisyirPenc()
  {
    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Alış fiyatını giriniz.",
        message: "İşleme devam edebilmek için fiyat giriniz.",
        inputs: [
          {
            name:'Fiyat',
            placeholder:'Alış Fiyatını Giriniz.',
            type:'number',
          }
          
        ],
     
        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {
              
            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
  

  alertSiparisMiktarGuncelle(masa) {
    return new Promise((res, err) => {
      var sonuc = false;
      let prompt = this.alert.create({
        title: "Miktar",
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: 'Miktar',
            type: "number"
          },
          // {
          //   name: 'rezerveDurumu',
          //   type: 'checkbox',
          //   label: 'Rezerve',
          //   value: 'value1',
          //   checked: masa.DURUM_ID == 2 ? true : false,
          // },

        ],
        buttons: [
          // {
          //   text: 'İptal',
          //   handler: data => {
          //     err();
          //   }
          // },
          {
            text: 'Tamam',
            handler: data => {
              sonuc = true;
              res({ values: data, miktar: 0 });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertSiparisKalemGuncelle(detay) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: detay.UrunName,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:" + " " + detay.Miktar,
            type: "number",


          },
          {
            name: 'fiyat',
            placeholder: "Alış Fiyatı:" + " " + detay.BirimFiyat,
            type: "number",


          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertMalKalemGuncelle(kalem) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: kalem.STOK_ADI,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:",
            type: "number",


          },
        

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertReceteMiktarGuncelle(kalem) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: kalem.STOK_ADI,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:",
            type: "number",


          },
        

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertIrsaliyeNoEkle() {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
          message: "",
          title:"İrsaliye Numarası ",
        inputs: [
          {
            name: 'irsNo',
            placeholder: "İrsaliye Numarası",
            type: "string",


          },
        

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertAmbalajGC() {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: 'Ambalaj G/C işlemi',
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:",
            type: "number",


          },
        

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  alertKalemGuncelle(hareket) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: hareket.StokAdi,
        message: "",
        inputs: [
          {
            name: 'miktar',
            placeholder: "Miktar:" + " " + hareket.Miktar,
            type: "number",


          },
          {
            name: 'fiyat',
            placeholder: "Fiyatı:" + " " + hareket.BirimFiyat,
            type: "number",


          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }
  paletyukle(ms) {
    return new Promise((res, err) => {
      // var sonuc = false;

      let prompt = this.alert.create({
        title: 'Palet Yükleme İşlemi',
        message: "",
        inputs: [
          {
            name: 'paletmiktar',
            placeholder: "Miktar:",
            type: "number",
            value:ms,


          },
          {
            name: 'yuklenecekmiktar',
            placeholder: "Miktar:",
            type: "number",


          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            handler: data => {
              // sonuc = true;
              res({ values: data, miktar: 0, });
            }
          }
        ]
      });
      prompt.present();
    })

  }



  TurkishToEnglish(phrase) {
    var returnString: string = phrase;

    //Convert Characters
    returnString = returnString.replace(/ö/g, 'o');
    returnString = returnString.replace(/ç/g, 'c');
    returnString = returnString.replace(/ş/g, 's');
    returnString = returnString.replace(/ı/g, 'i');
    returnString = returnString.replace(/ğ/g, 'g');
    returnString = returnString.replace(/ü/g, 'u');
    returnString = returnString.replace(/Ö/g, 'O');
    returnString = returnString.replace(/Ç/g, 'C');
    returnString = returnString.replace(/Ş/g, 'S');
    returnString = returnString.replace(/İ/g, 'I');
    returnString = returnString.replace(/Ğ/g, 'G');
    returnString = returnString.replace(/Ü/g, 'U');
    return returnString;
  }
  formatMoney(girdi, fractionDigits?, decimal?, separator?) {
    if (fractionDigits == null)
      fractionDigits = 2;
    if (decimal == null)
      decimal = ",";
    if (separator == null)
      separator = ".";
    fractionDigits = isNaN(fractionDigits = Math.abs(fractionDigits)) ? 2 : fractionDigits;

    decimal = typeof (decimal) === "undefined" ? "." : decimal;

    separator = typeof (separator) === "undefined" ? "," : separator;

    var number = girdi;

    var neg = number < 0 ? "-" : "";

    var wholePart: any = parseInt(number = Math.abs(+number || 0).toFixed(fractionDigits)) + "";

    var separtorIndex = (separtorIndex = wholePart.length) > 3 ? separtorIndex % 3 : 0;

    return neg +

      (separtorIndex ? wholePart.substr(0, separtorIndex) + separator : "") +

      wholePart.substr(separtorIndex).replace(/(\d{3})(?=\d)/g, "$1" + separator) +

      (fractionDigits ? decimal + Math.abs(number - wholePart).toFixed(fractionDigits).slice(2) : "");


  }

  
  formatMilyon(girdi, fractionDigits?, decimal?, separator?) {
    if(girdi!=null)
    {
     if (fractionDigits == null)
     fractionDigits = 2;
   if (decimal == null)
     decimal = ",";
   if (separator == null)
     separator = ".";
   fractionDigits = isNaN(fractionDigits = Math.abs(fractionDigits)) ? 2 : fractionDigits;
 
   decimal = typeof (decimal) === "undefined" ? "." : decimal;
 
   separator = typeof (separator) === "undefined" ? "." : separator;
 
   var number = girdi;
 
   var neg = number < 0 ? "-" : "";
 
   var wholePart: any = parseInt(number = Math.abs(+number || 0).toFixed(fractionDigits)) + "";
 
   var separtorIndex = (separtorIndex = wholePart.length) > 3 ? separtorIndex % 3 : 0;
 
   return neg +
 
     (separtorIndex ? wholePart.substr(0, separtorIndex) + separator : "") +
 
     wholePart.substr(separtorIndex).replace(/(\d{3})(?=\d)/g, "$1" + separator) +
 
     (fractionDigits ? decimal + Math.abs(number - wholePart).toFixed(fractionDigits).slice(2) : "");
 
    }
 
   }
  alertAktarimPenceresi() {

    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Miktar giriniz.",
        message: "Siparişe aktarınlan miktarı giriniz..",
        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'number',

          },
       

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
  alertSatisAktarimPenceresi(detay) {

    return new Promise((res, err) => {
      let prompt = this.alert.create({
        title: "Miktar ve Satış fiyatını giriniz.",
        message: "1.Miktar 2.Satış Fiyatı",


        inputs: [
          {
            name: 'Miktar',
            placeholder: 'Miktarı Giriniz.',
            type: 'number',

          },


          {
            name: 'Fiyat',
            placeholder: 'Satış Fiyatını Giriniz.',
            type: 'number',
            value: detay.Price2,

          }

        ],

        buttons: [
          {
            text: 'İptal',
            role: 'cancel',
            handler: data => {

            }
          },
          {
            text: 'Tamam',
            role: 'submit',
            handler: data => {
              res({ values: data });
            }
          }
        ]
      });
      prompt.present();
    })
  }
  ExportExcel(data, dosya_ismi: string) {
    return new Promise((res, err) => {
      if (data.length > 0) {
        dosya_ismi = dosya_ismi
        json2excel({
          data,
          name: dosya_ismi,
          formateDate: 'yyyy/mm/dd'
        });
        res();
      }
      else
        err();
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/ortak.ts